
export const FORM_ACTION_STARTED = 'FORM_ACTION_STARTED';
export const FORM_ACTION_FINISHED = 'FORM_ACTION_FINISHED';
